import React from 'react';
import { ItemPath } from '../../../../order.schema';
import { ApiItems } from '../../../../types';
import { useItemsAutofill } from '../../../../Hooks/useItemAutofill';
import { MaterialLegacySections } from '../Legacy/MaterialLegacySections';
import FeedstockSection from '../../Product/FeedstockSection';
import { SHOW_LEGACY_SECTIONS } from '../../../../constants';

interface FormMaterialProps {
  itemPath: ItemPath;
  itemOptionsFromApi: ApiItems[];
  formatOptionsList: string[];
  finishingOptionsList: string[];
}

export const FormMaterial: React.FC<FormMaterialProps> = (props) => {
  useItemsAutofill({ itemPath: props.itemPath, itemOptionsFromApi: props.itemOptionsFromApi });

  return (
    <>
      <FeedstockSection itemPath={props.itemPath} />

      {SHOW_LEGACY_SECTIONS && (
        <MaterialLegacySections {...props} />
      )}
    </>
  );
};